import { RouterLink } from 'vue-router'

export default {
  name: 'page-element-logo',
  props: {
    logo: {
      type: String,
      required: false,
      default: 'logo'
    }
  },
  computed: {
    path() {
      return `/dist/logos/website/${this.logo}.svg`
    },
    url() {
      return this.$store.getters['getModuleSetting']('homepage', 'logo-url', '/')
    },
    relativeLink() {
      return this.$store.getters['getModuleSetting']('homepage', 'logo-url-relative', true)
    },
    linkComponent() {
      return this.relativeLink ? RouterLink : 'a'
    },
    linkProps() {
      if (this.relativeLink) {
        return { to: this.url }
      }

      return {
        href: this.url
      }
    }
  }
}
